/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Fctitle1Inputs */

const zh_landing_admin_fctitle1 = /** @type {(inputs: Landing_Admin_Fctitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真正帮你记住的智能闪卡`)
};

const en_landing_admin_fctitle1 = /** @type {(inputs: Landing_Admin_Fctitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Flashcards That Actually Stick`)
};

const es_landing_admin_fctitle1 = /** @type {(inputs: Landing_Admin_Fctitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas inteligentes que de verdad se quedan`)
};

/**
* | output |
* | --- |
* | "Smart Flashcards That Actually Stick" |
*
* @param {Landing_Admin_Fctitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_fctitle1 = /** @type {((inputs?: Landing_Admin_Fctitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Fctitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_fctitle1(inputs)
	if (locale === "en") return en_landing_admin_fctitle1(inputs)
	return es_landing_admin_fctitle1(inputs)
});
export { landing_admin_fctitle1 as "landing_admin_fcTitle" }